import { render } from "./Modal.vue?vue&type=template&id=f81946b6&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=f81946b6&lang=css"

import exportComponent from "/Users/milberferreira/Projects/towkns/towkns-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__